import { motion } from 'framer-motion';
import Skeleton from './Skeleton';

export const HeaderSkeleton = () => (
  <motion.header
    className="bg-slate-900/90 dark:bg-slate-900/90 backdrop-blur-2xl border-b border-slate-800/60 dark:border-slate-800/60 sticky top-0 z-50 shadow-lg dark:shadow-xl dark:shadow-black/40"
    initial={{ y: -100 }}
    animate={{ y: 0 }}
    transition={{ duration: 0.3 }}
  >
    <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
      {/* Logo */}
      <div className="flex items-center gap-2">
        <Skeleton className="w-10 h-10 rounded-xl" />
        <Skeleton className="h-6 w-32 hidden sm:block" />
      </div>

      {/* Desktop Nav */}
      <div className="hidden md:flex gap-8">
        <Skeleton className="h-5 w-16" />
        <Skeleton className="h-5 w-16" />
      </div>

      {/* Cart Button with Badge */}
      <div className="flex items-center gap-4">
        <div className="relative">
          <Skeleton className="h-10 w-12 rounded-xl" />
          <Skeleton className="absolute -top-2 -right-2 h-5 w-5 rounded-full" />
        </div>
        <Skeleton className="md:hidden h-6 w-6 rounded" />
      </div>
    </div>
  </motion.header>
);

export const StoreLayoutSkeleton = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-blue-950 dark">
    {/* Header */}
    <HeaderSkeleton />

    {/* Main Content */}
    <main className="max-w-7xl mx-auto px-4 py-12">
      <div className="space-y-8">
        {/* Hero Banner */}
        <div className="rounded-2xl p-8 md:p-12 bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 space-y-3">
          <Skeleton className="h-10 w-2/3" />
          <Skeleton className="h-5 w-full" />
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="rounded-3xl overflow-hidden border border-slate-700 bg-slate-800/60 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="relative">
                <Skeleton className="w-full h-48 rounded-t-3xl" />
                <div className="absolute top-3 right-3">
                  <Skeleton className="h-5 w-16 rounded-full" />
                </div>
              </div>
              <div className="p-5 space-y-4">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-6 w-3/4" />
                <Skeleton className="h-4 w-48" />
                <div className="flex items-center justify-between pt-3">
                  <Skeleton className="h-7 w-24 rounded-lg" />
                </div>
                <Skeleton className="h-10 w-full rounded-xl" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>

    {/* Footer */}
    <motion.footer
      className="bg-gradient-to-b from-slate-900 via-slate-800 to-slate-950 text-white mt-20 border-t border-slate-700/60 relative overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="space-y-4">
              <Skeleton className="h-6 w-32" />
              <div className="space-y-3">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-5/6" />
                <Skeleton className="h-4 w-4/5" />
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-slate-700/50 pt-8 text-center">
          <Skeleton className="h-4 w-48 mx-auto" />
        </div>
      </div>
    </motion.footer>
  </div>
);
